import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const UploadFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
  })
);
